import { render } from "./PreChatForm.vue?vue&type=template&id=700e68ef&scoped=true"
import script from "./PreChatForm.vue?vue&type=script&lang=js"
export * from "./PreChatForm.vue?vue&type=script&lang=js"

import "./PreChatForm.vue?vue&type=style&index=0&id=700e68ef&scoped=true&lang=sass"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700e68ef"]])

export default __exports__